import { render, staticRenderFns } from "./LoadingSpin.vue?vue&type=template&id=2da3d980"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da3d980')) {
      api.createRecord('2da3d980', component.options)
    } else {
      api.reload('2da3d980', component.options)
    }
    module.hot.accept("./LoadingSpin.vue?vue&type=template&id=2da3d980", function () {
      api.rerender('2da3d980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/LoadingSpin.vue"
export default component.exports